// Values must match SnowflakeEditionEnum's [EnumMember] strings on the backend, which the
// type-level StringEnumConverter keeps verbatim rather than camelCasing.
enum SnowflakeEditionEnum {
  Standard = "Standard",
  Enterprise = "Enterprise",
  BusinessCritical = "Business Critical",
}

export { SnowflakeEditionEnum };
